(() => {
  if (window.motHighlightsInitialized) return;
  window.motHighlightsInitialized = true;
  let activeDrawer = null;
  let returnFocus = null;
  let closeTimer;
  const toggles = () => Array.from(document.querySelectorAll('[data-mot-highlights-toggle]'));
  const synchronize = () => {
    const drawer = document.querySelector('[data-mot-highlights-drawer]');
    toggles().forEach((button) => {
      button.hidden = !drawer;
      button.setAttribute('aria-expanded', String(Boolean(drawer?.open)));
      button.closest('[data-mot-navigation]')?.classList.toggle('has-highlights', Boolean(drawer));
    });
  };
  const finishClose = () => {
    clearTimeout(closeTimer);
    const drawer = activeDrawer;
    activeDrawer = null;
    drawer?.classList.remove('is-closing');
    if (drawer?.open) drawer.close();
    document.documentElement.classList.remove('mot-highlights-open');
    synchronize();
    if (returnFocus?.isConnected) returnFocus.focus({ preventScroll:true });
    returnFocus = null;
  };
  const close = (immediate = false) => {
    if (!activeDrawer) return;
    if (immediate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) finishClose();
    else {
      activeDrawer.classList.add('is-closing');
      clearTimeout(closeTimer);
      closeTimer = setTimeout(finishClose,180);
    }
  };
  const open = (button) => {
    const drawer = document.querySelector('[data-mot-highlights-drawer]');
    if (!drawer || drawer.open) return;
    clearTimeout(closeTimer);
    returnFocus = button || document.activeElement;
    if (typeof window.upcartCloseCart === 'function') window.upcartCloseCart();
    activeDrawer = drawer;
    drawer.classList.remove('is-closing');
    drawer.showModal();
    document.documentElement.classList.add('mot-highlights-open');
    synchronize();
    drawer.querySelector('.mot-highlights__title')?.focus({ preventScroll:true });
  };
  const initialize = () => {
    synchronize();
    document.querySelectorAll('[data-mot-highlights-drawer]').forEach((drawer) => {
      if (drawer.dataset.initialized) return;
      drawer.dataset.initialized = 'true';
      drawer.addEventListener('cancel', (event) => { event.preventDefault(); close(); });
      drawer.addEventListener('keydown', (event) => {
        if (event.key !== 'Tab') return;
        const focusable = Array.from(drawer.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled])')).filter((element) => element.getClientRects().length);
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus({ preventScroll:true }); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus({ preventScroll:true }); }
      });
      drawer.addEventListener('close', () => {
        if (activeDrawer === drawer) finishClose();
      });
      drawer.addEventListener('click', (event) => {
        if (event.target !== drawer) return;
        const bounds = drawer.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) close();
      });
    });
  };
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-mot-highlights-toggle]');
    if (button) open(button);
    else if (event.target.closest('[data-mot-highlights-close]')) close();
    else if (event.target.closest('[data-mot-highlights-drawer] a[href]')) close(true);
  });
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', (event) => {
    if (activeDrawer && event.target.contains(activeDrawer)) close(true);
    requestAnimationFrame(synchronize);
  });
  document.addEventListener('shopify:block:select', (event) => {
    const card = event.target.closest('[data-mot-highlight]');
    if (!card) return;
    open(toggles()[0]);
    requestAnimationFrame(() => card.scrollIntoView({ block:'nearest', behavior:'instant' }));
  });
  document.addEventListener('shopify:section:select', (event) => {
    if (event.target.querySelector('[data-mot-highlights-drawer]')) open(toggles()[0]);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once:true });
  else initialize();
})();
